import { useQuery } from '@apollo/client';

import type { FilterConfig, Query } from '../../../../../apis/graphql';
import { GET_TRAFFICKING_FILTER_CONFIG } from '../../../FilterPanel/queries/getTraffickingFilterConfig';

export type UseGetTraffickingFilterConfigResult = {
  filterConfigs: FilterConfig[];
  loading: boolean;
  error: string | undefined;
};

const EMPTY_FILTER_CONFIGS: FilterConfig[] = [];

export const useGetTraffickingFilterConfig = (): UseGetTraffickingFilterConfigResult => {
  const { data, loading, error } = useQuery<Pick<Query, 'getTraffickingFilterConfig'>>(GET_TRAFFICKING_FILTER_CONFIG);

  return {
    filterConfigs: data?.getTraffickingFilterConfig ?? EMPTY_FILTER_CONFIGS,
    loading,
    error: error?.message,
  };
};
